import React from "react";
import Panel from "../Panel";
import CropComponent from "../CropComponent";
import UpgradeModal from "../UpgradeModal";
import ErrorBoundary from "../ErrorBoundary";
import { handleUpgradeRedirect, FREE_UPLOAD_LIMIT } from "../../utils/general";
import baseUrl from "../../config";

function PreviewPanel({
  isSmallScreen,
  iframeSrc,
  iframeRef,
  onIframeLoad,
  showPanel,
  panelPosition,
  isLink,
  webViewMode,
  applyCommand,
  handleLinkClick,
  handleIframeLinkClick,
  removeLink,
  showCropDialog,
  setShowCropDialog,
  selectedImage,
  aspect,
  actualImage,
  handleChanges,
  accessToken,
  domain,
  showUpgradeModal,
  closeUpgradeModal,
  userProfile,
  modalContext,
}) {
  return (
    <div className={`webmode ${isSmallScreen ? "show-on-small-screen" : ""}`}>
      <div className="mini-navbar" />
      <iframe
        id="demo-iframe"
        title="Template"
        src={iframeSrc}
        width="100%"
        height="100%"
        ref={iframeRef}
        onLoad={onIframeLoad}
      />

      {/* Formatting Panel */}
      {showPanel && (
        <ErrorBoundary>
          <Panel
            panelTop={panelPosition.top}
            panelRight={panelPosition.right}
            panelLink={isLink}
            applyCommand={applyCommand}
            handleLinkClick={handleLinkClick}
            handleIframeLinkClick={handleIframeLinkClick}
            removeLink={removeLink}
            webviewmode={webViewMode}
          />
        </ErrorBoundary>
      )}

      {/* Crop Modal */}
      <ErrorBoundary>
        <CropComponent
          showCropDialog={showCropDialog}
          setShowCropDialog={setShowCropDialog}
          selectedImage={selectedImage}
          aspect={aspect}
          actualImage={actualImage}
          handleChanges={handleChanges}
          baseUrl={baseUrl}
          accessToken={accessToken}
          domain={domain}
        />
      </ErrorBoundary>

      {/* Upgrade Modal */}
      <UpgradeModal
        title="You've reached your daily upload limit"
        show={showUpgradeModal}
        desc={`You can only edit your project ${FREE_UPLOAD_LIMIT} times per day, please upgrade or return tomorrow.`}
        cta="Upgrade now"
        onClick={handleUpgradeRedirect}
        onHide={closeUpgradeModal}
        userProfile={userProfile}
        modalContext={modalContext}
      />
    </div>
  );
}

export default React.memo(PreviewPanel);
